<script setup>
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
</script>

<template>
  <footer class="site-footer">
    <div class="foot-left"><a href="https://wa.me/6282285711146" target="_blank" style="color: aliceblue;"><i class="bi bi-headset"></i> {{ t('footer.contactSupport') }} </a></div>
    <div class="foot-center">{{ t('footer.copyright') }}</div>
    <div class="foot-right"></div>
  </footer>
</template>

<style scoped src="./style/AppFooter.css"></style>

